import { css } from 'aphrodite';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { NavLink } from 'react-router-dom';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { Page } from '../../../components-v2/PageLayout';
import { TabContent, TabList, TabRoot, TabTrigger } from '../../../components-v2/Tabs';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../../components/Breadcrumb';
import { MultiContainerHeader } from '../../../components/MultiContainerHeader';
import { ROUTES } from '../../../constants/routes';
import { baseStyleSheet } from '../../../styles/styles';
import { styleSheet as advancedReportingStyleSheet } from '../styles';
import { BookHistoryTab } from './BookHistoryTab';
import { CurrentBookTab } from './CurrentBookTab';

const BOOK_TABS = ['current', 'history'] as const;
type BookTab = (typeof BOOK_TABS)[number];

export const PoliciesAdvancedReporting = () => {
	const userSession = useUserSession();
	const historyEnabled = userSession.account?.features?.policyHistory?.enabled ?? false;
	const [tab, setTab] = useQueryState('tab', parseAsStringLiteral(BOOK_TABS).withDefault('current'));

	return (
		<Page>
			<div className={css(advancedReportingStyleSheet.pageContainer)}>
				<MultiContainerHeader
					appBarHeader={
						<Breadcrumb>
							<BreadcrumbList>
								<BreadcrumbItem>
									<BreadcrumbLink asChild>
										<NavLink to={ROUTES.dataBoards.home}>
											<h1 className={css(baseStyleSheet.breadcrumbTitle)}>Data Boards</h1>
										</NavLink>
									</BreadcrumbLink>
								</BreadcrumbItem>
								<BreadcrumbSeparator />
								<BreadcrumbItem>
									<BreadcrumbLink asChild>
										<NavLink to={ROUTES.dataBoards.policies}>
											<h1 className={css(baseStyleSheet.breadcrumbTitle)}>Policies</h1>
										</NavLink>
									</BreadcrumbLink>
								</BreadcrumbItem>
								<BreadcrumbSeparator />
								<BreadcrumbItem>
									<BreadcrumbPage>Advanced Reporting</BreadcrumbPage>
								</BreadcrumbItem>
							</BreadcrumbList>
						</Breadcrumb>
					}
				/>

				{historyEnabled ? (
					<TabRoot value={tab} onValueChange={value => setTab(value as BookTab)}>
						<TabList>
							<TabTrigger value='current'>Current book</TabTrigger>
							<TabTrigger value='history'>Book history</TabTrigger>
						</TabList>
						<TabContent value='current'>
							<CurrentBookTab onViewHistory={() => setTab('history')} />
						</TabContent>
						<TabContent value='history'>
							<BookHistoryTab
								trackingSince={userSession.account?.features?.policyHistory?.trackingSince}
								baselineCompleted={userSession.account?.features?.policyHistory?.baselineCompleted}
							/>
						</TabContent>
					</TabRoot>
				) : (
					<CurrentBookTab />
				)}
			</div>
		</Page>
	);
};
